// Service types and default rates
export const SERVICE_RATES = {
    fullProduction: { label: 'Full Production', rate: 3500, hours: 40, royaltyPercent: 20 },
    mixing: { label: 'Mixing', rate: 800, hours: 7, royaltyPercent: 0 },
    dolbyAtmos: { label: 'Dolby Atmos', rate: 500, hours: 6, royaltyPercent: 0 },
    mastering: { label: 'Mastering', rate: 250, hours: 1, royaltyPercent: 0 },
} as const;

// Survival floor: minimum weekly income needed
export const WEEKLY_MINIMUM = 2000;
export const HOURLY_FLOOR = WEEKLY_MINIMUM / 40; // $50/hr

export type ServiceKey = keyof typeof SERVICE_RATES;

// Streaming revenue constants
export const CPM_RATES = {
    conservative: 3,
    moderate: 4,
    optimistic: 5,
} as const;

export const STREAMS_PER_LISTENER = {
    conservative: 4,
    moderate: 5,
    optimistic: 6.5,
} as const;

// Growth projection multipliers
export const SCENARIO_MULTIPLIERS = {
    conservative: 0.5,
    moderate: 1.0,
    optimistic: 1.5,
} as const;

export type Scenario = keyof typeof SCENARIO_MULTIPLIERS;

// Growth caps
export const MAX_MONTHLY_GROWTH = 0.15; // +15%/month
export const MIN_MONTHLY_GROWTH = -0.05; // -5%/month

// Live revenue defaults
export const LIVE_DEFAULTS = {
    fillRate: 0.7,
    headlinerShare: 0.15, // producer's cut of live
} as const;

// Verdict thresholds (based on 24-month moderate projection)
export const VERDICT_THRESHOLDS = {
    takeIt: 0.9,   // >= 90% of standard earnings
    counter: 0.6,  // >= 60% of standard earnings
    // below 60% = walk away
} as const;

// Projection periods
export const PROJECTION_MONTHS = [12, 24, 36] as const;

// New release boost: a freshly released track gets more streams than the
// catalog average because of algorithmic push, playlist placement, etc.
export const NEW_RELEASE_BOOST = 2.0;

// Max backend split to suggest — anything above this is unrealistic
export const MAX_REASONABLE_SPLIT = 40;
